
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import VehicleTypes from './components/VehicleTypes';
import Insurance from './components/Insurance';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SeoJsonLd from '../../components/feature/SeoJsonLd';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <SeoJsonLd />
      <Navbar />
      <Hero />
      <Services />
      <VehicleTypes />
      <Insurance />
      <About />
      <Contact />
      <Footer />
    </div>
  );
}
